module.exports = __webpack_public_path__ + "df26146e63718295755e851ca1126eed.svg";